import React from 'react';

import Image from 'next/image';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './Card.module.scss';

type CardProps = {
    articleIndex: number;
};

const Card = ({ articleIndex }: CardProps) => {
    const { t } = useTranslateLpc('lpc-solidarity-page');

    return (
        <div className={css.card_container} key={articleIndex}>
            <div className={css.card_container__card}>
                <div className={css.card_container__card__image_container}>
                    <Image
                        width={56}
                        height={56}
                        src={`/front-static/images/landings/solidarity-page/${articleIndex + 1}.png`}
                        alt={t(`hero.actions.${articleIndex}.name`)}
                    />
                </div>
                <div className={css.card_container__card__text_container}>
                    <Text
                        variant={'body_02'}
                        color={'black-gray'}
                        html
                        htmlText={t(`hero.actions.${articleIndex}.name`)}
                        customClass={css.card_container__card__text_container__name}
                    />
                    <Text
                        variant={'footer'}
                        color={'black-gray'}
                        html
                        htmlText={t(`hero.actions.${articleIndex}.text`)}
                        customClass={css.card_container__card__text_container__text}
                    />
                </div>
            </div>
        </div>
    );
};
export default Card;
